import { getPrefixedVar } from '@private/payment';
import styled from 'styled-components';

import Typography from 'components/Typography';

import { ErrorMessage as Error } from '../ErrorMessage';

const prefix = ['components', 'form', 'section'];

export const Container = styled.div`
  padding: 32px 32px 12px;
  background-color: ${getPrefixedVar([...prefix, 'bg'])};
  border-radius: ${getPrefixedVar([...prefix, 'borderRadius'])};
`;

export const Title = styled(Typography)`
  color: ${getPrefixedVar([...prefix, 'text'])};
  white-space: nowrap;
`;

export const Header = styled.div<{ $isSpaceBetween?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $isSpaceBetween }) =>
    $isSpaceBetween ? 'space-between' : 'unset'};
  column-gap: 18px;
  margin-bottom: 24px;
`;

export const HintMessage = styled(Typography).attrs(() => ({
  size: 'sm',
}))`
  margin-left: 10px;
  color: ${getPrefixedVar(['merchants', 'form', 'hint'])};
`;

export const ErrorMessage = styled(Error).attrs(() => ({
  size: 'sm',
}))`
  margin-left: 10px;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 5px;
`;
